import React from 'react'

import RangeFilter from './RangeFilter'
import SelectManyFilter from './SelectManyFilter'
import ToggleFilter from './ToggleFilter'
import { FilterDef } from './types'
import DateRangeFilter from './DateRangeFilter'
import DateFilter from './DateFilter'

export default function Filter({
  filterDef,
  searchOptions,
  searchOptionsLoading,
  onSearch,
  onChange,
}: {
  filterDef: FilterDef
  searchOptions?: {
    label: string | React.ReactNode
    value: string
  }[]
  searchOptionsLoading?: boolean
  onSearch?: (val: string) => void
  onChange?: () => void
}) {
  switch (filterDef.type) {
    case 'select-many':
      return (
        <SelectManyFilter
          filterDef={filterDef}
          searchOptions={searchOptions}
          searchOptionsLoading={searchOptionsLoading}
          onSearch={onSearch}
          onChange={onChange}
          data-testid="select-many-filter"
        />
      )
    case 'range':
      return <RangeFilter filterDef={filterDef} onChange={onChange} />
    case 'date':
      return <DateFilter filterDef={filterDef} onChange={onChange} />
    case 'date-range':
      return <DateRangeFilter filterDef={filterDef} onChange={onChange} />
    case 'toggle':
      return <ToggleFilter filterDef={filterDef} onChange={onChange} />
    default:
      return null
  }
}
